import {YandexMetrikaProvider} from './providers/yandex-metrika-provider';
import {GoogleAnalyticsProvider} from './providers/google-analytics-provider';
import {getAnalytics} from './analytics';
import type {AnalyticsConfig} from './types';

function toNumber(value: unknown): number | null {
  if (value === null || value === undefined || value === '') return null;
  const num = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(num) && num > 0 ? num : null;
}

export function configureAnalyticsFromSettings(analytics?: {
  yandex_metrika_id?: string;
  tracking_code?: string;
}): void {
  const config: AnalyticsConfig = {
    yandexMetrikaId: toNumber(analytics?.yandex_metrika_id),
    googleTrackingCode: analytics?.tracking_code ?? null,
  };

  const providers = [
    new YandexMetrikaProvider(config.yandexMetrikaId),
    new GoogleAnalyticsProvider(config.googleTrackingCode),
  ];

  getAnalytics().configure(config, providers);
}
